import { render, staticRenderFns } from "./generalServicesDialog.vue?vue&type=template&id=6c6bbf86"
import script from "./generalServicesDialog.vue?vue&type=script&lang=js"
export * from "./generalServicesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports